$(function(){
    $('.js-fab-chat').on('click', function(){
        var $fabContainer = $(this).prev('.chat-card').parent('.fab-container');
        $(this).toggleClass('active');
        $(this).prev('.chat-card').toggleClass('open');
        
        if($(this).hasClass('active')){
            $fabContainer.css('height', '600px');
        }else {
            $fabContainer.css('height', '0');
        }
    })
    $('.chat-card-links li').each(function () {
        var chatId = $(this).find('[data-chatagentid]').data('chatagentid');
        if (!window._laq) { window._laq = []; }
        console.log(chatId)
        window._laq.push(function() {
            liveagent.showWhenOnline(
                chatId, 
                document.getElementsByClassName('liveagent_chat')
            );
            liveagent.showWhenOffline(
                chatId , 
                document.getElementsByClassName('liveagent_offline')
            );
        });
    });
});